import { useState } from 'react'

interface AvatarProps {
  name: string
  src?: string
  size?: 'xs' | 'sm-table' | 'sm' | 'md' | 'lg' | 'panel-lg'
  className?: string
}

const sizeClasses = {
  xs: 'h-6 w-6 text-[10px]',
  'sm-table': 'h-8 w-8 text-[11px]',
  sm: 'h-11 w-11 text-sm',
  md: 'h-12 w-12 text-base',
  lg: 'h-20 w-20 text-xl',
  'panel-lg': 'h-16 w-16 text-h4',
} as const

function getInitials(name: string) {
  if (!name) return 'U'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) {
    return parts[0].length <= 2 ? parts[0].toUpperCase() : (parts[0][0]?.toUpperCase() ?? '')
  }
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}

export function Avatar({ name, src, size = 'md', className = '' }: AvatarProps) {
  const [hasError, setHasError] = useState(false)

  if (src && !hasError) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setHasError(true)}
        referrerPolicy="strict-origin-when-cross-origin"
        className={`${sizeClasses[size]} rounded-full border-2 border-white object-cover shadow-sm ${className}`}
      />
    )
  }

  return (
    <div
      aria-label={name}
      className={`${sizeClasses[size]} inline-flex items-center justify-center rounded-full bg-[#146971] font-semibold text-white ${className}`}
    >
      {getInitials(name)}
    </div>
  )
}
